module.exports = __webpack_public_path__ + "static/media/factory-list-place-holder.b77552b6.svg";